import { render, staticRenderFns } from "./TrDemoMessages.vue?vue&type=template&id=f7a156f6&scoped=true&"
import script from "./TrDemoMessages.vue?vue&type=script&lang=js&"
export * from "./TrDemoMessages.vue?vue&type=script&lang=js&"
import style0 from "./TrDemoMessages.vue?vue&type=style&index=0&id=f7a156f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a156f6",
  null
  
)

export default component.exports